<ng-container *ngIf="!(authCheck$ | async); else loading">
  <ng-container *ngIf="step === 'signup'">
    <div class="flex justify-center items-center">
      <div class="w-full mx-2 sm:mx-0 sm:w-1/2 xl:w-1/3 2xl:w-1/3">
        <h2 class="text-white">Sign up</h2>

        <form [formGroup]="signupForm" novalidate>
          <div class="mb-6">
            <label
              for="email"
              class="block mb-2 text-sm font-medium"
              [class.dark:text-red-500]="
                email.invalid && (email.dirty || email.touched)
              "
              >Email</label
            >
            <input
              type="email"
              formControlName="email"
              class="input-dark"
              [ngClass]="{
                'input-error': email.invalid && (email.dirty || email.touched),
              }"
            />
            <div *ngIf="email.invalid && (email.dirty || email.touched)">
              <p
                *ngIf="email.errors?.['required']"
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Email is required.
              </p>
              <p
                *ngIf="email.errors?.['email']"
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Please provide a valid email address.
              </p>
            </div>
          </div>
          <div class="mb-6">
            <label
              for="password"
              class="block mb-2 text-sm font-medium"
              [class.dark:text-red-500]="
                password.invalid && (password.dirty || password.touched)
              "
              >Password</label
            >
            <input
              type="password"
              formControlName="password"
              class="input-dark"
              [ngClass]="{
                'input-error':
                  password.invalid && (password.dirty || password.touched),
              }"
            />
            <div
              *ngIf="password.invalid && (password.dirty || password.touched)"
            >
              <p
                *ngIf="password.errors?.['required']"
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Password is required.
              </p>
              <p
                *ngIf="password.errors?.['minlength']"
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Please enter at least 8 characters.
              </p>
              <p
                *ngIf="
                  !password.errors?.['minlength'] &&
                  password.errors?.['pattern']
                "
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Please use at least one letter, one number and one special
                character (&#64;#$%^&+=!*).
              </p>
            </div>
          </div>
          <div class="flex items-start mb-6">
            <div class="flex items-center h-5">
              <input
                formControlName="terms"
                id="terms"
                type="checkbox"
                (change)="toggleTerms($event)"
                class="w-4 h-4 bg-gray-50 rounded border border-gray-300 focus:ring-3 focus:ring-gray-200 dark:bg-gray-700 dark:border-gray-600 focus:ring-gray-200 dark:ring-offset-gray-800"
                [ngClass]="{
                  'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-red-100 dark:border-red-400 dark:text-red-400':
                    terms.invalid && (terms.dirty || terms.touched),
                }"
              />
            </div>
            <label
              for="terms"
              class="ml-2 text-sm font-medium"
              [class.dark:text-red-500]="
                terms.invalid && (terms.dirty || terms.touched)
              "
              >I agree to the
              <a [href]="termsUrl" target="_blank">Terms of Service</a></label
            >
          </div>

          <div class="w-100 flex flex-col items-center justify-center mt-12">
            <button
              class="btn-primary plausible-event-name=CreatedAccount"
              (click)="signup()"
              [disabled]="busy"
            >
              Create new account<app-spinner
                class="ml-2 mt-1"
                *ngIf="busy"
              ></app-spinner>
            </button>
            <div *ngIf="error" class="mt-5 text-red-500 text-center">
              Error creating account, please try again in a few moments.
            </div>
            <p class="mt-12 text-sm">
              Already have an account? <a routerLink="/">Login</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="step === 'verify'">
    <div class="flex justify-center items-center">
      <div class="w-full mx-2 sm:mx-0 sm:w-1/2 xl:w-1/3 2xl:w-1/3">
        <h2 class="text-white mb-3">Verify your email</h2>
        <p class="mb-6 text-sm">
          Thanks for signing up! We have sent a code to your email address.
          Please enter the code below to verify your email address.
        </p>
        <form [formGroup]="verifyEmailForm" novalidate>
          <div class="mb-6">
            <label
              for="code"
              class="block mb-2 text-sm font-medium"
              [class.dark:text-red-500]="
                code.invalid && (code.dirty || code.touched)
              "
              >Code</label
            >
            <input
              type="text"
              formControlName="code"
              class="input-dark"
              [ngClass]="{
                'input-error': code.invalid && (code.dirty || code.touched),
              }"
            />
            <div *ngIf="code.invalid && (code.dirty || code.touched)">
              <p
                *ngIf="code.errors?.['required']"
                class="mt-2 text-sm text-red-600 dark:text-red-500"
              >
                Code is required.
              </p>
            </div>
          </div>
          <div class="w-100 flex flex-col items-center justify-center mt-12">
            <button
              class="btn-primary"
              (click)="verifyEmail()"
              [disabled]="busy"
            >
              Verify email<app-spinner
                class="ml-2 mt-1"
                *ngIf="busy"
              ></app-spinner>
            </button>
            <p *ngIf="error" class="mt-5 text-red-500">
              Error verifying your email. Please try again.
            </p>
          </div>
        </form>
        <p class="text-sm mt-20 text-center">
          Didn't get the email?
          <a (click)="resendConfirmationEmail()" class="cursor-pointer"
            >Resend it</a
          >
          or
          <a href="mailto:support@clouddeck.app">contact support.</a>
        </p>
        <p class="text-sm mt-4 text-center">
          Entered the wrong email?
          <a
            (click)="cancelSignup()"
            class="cursor-pointer"
            [class.pointer-events-none]="busy"
            [class.opacity-50]="busy"
            >Cancel signup and start over</a
          >.
        </p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="step === 'redirect'">
    <div class="flex flex-col justify-center items-center mt-20">
      <p class="text-2xl">
        Thanks for signing up! You can now <a routerLink="/">log in.</a>
      </p>
      <p class="mt-5">We will redirect you shortly.</p>
    </div>
  </ng-container>
</ng-container>
<ng-template #loading>
  <div class="w-full flex justify-center">
    <app-spinner class="mr-2"></app-spinner>Loading
  </div>
</ng-template>
